// @flow
import React, { useContext } from 'react';
import injectSheet from 'react-jss';
import _ from 'shared/lib/gettext';
import EditorContext from 'shared/components/EditorContext';

type Props = {
  classes: Object,
  onClick: () => void,
  slotId: string,
  onDragEnter: Function,
  onDragOver: Function,
  onDrop: Function,
  onDragEnd: Function
};

const getSlotLabel = (slotId) => {
  let label = '';

  switch (slotId) {
    case 'menu-bar':
      label = 'to Header';
      break;
    case 'content':
      label = 'to Body';
      break;
    case 'footer':
      label = 'to Footer';
      break;
    case 'left-col':
      label = 'to Left Column';
      break;
    case 'right-col':
      label = 'to Right Column';
      break;
    case 'top-section':
      label = 'to Top Section';
      break;
    case 'additional-content':
      label = 'to Additional Content';
      break;
    case 'header-right':
      label = 'to Header Right';
      break;
    case 'tab-menu':
      label = 'to Tab Menu';
      break;
    case 'flexible-column':
      label = 'to Flexible Column';
      break;
    case 'responsive-display-container':
      label = 'to Responsive Display Container';
      break;
    case 'column':
      label = 'to Column';
      break;
    case 'slide-show-content':
      label = ' to Slide Show Content';
      break;
    default:
      label = '';
  }

  return `${_('ADD_COMPONENT')} ${label}`;
};

function AddComponent({
  classes: c,
  onClick,
  slotId,
  onDragEnter,
  onDragOver,
  onDrop,
  onDragEnd,
}: Props) {
  const { isBasicUser } = useContext(EditorContext)
  if (isBasicUser) {
    return null;
  }

  return (
    <div
      className={c.container}
      onClick={onClick}
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
    >
      <i className="material-icons">add_circle</i>
      <span>{getSlotLabel(slotId)}</span>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '68px',
    cursor: 'pointer',
    fontFamily: 'Montserrat, sans-serif',
    zIndex: '3',
    '& > .material-icons': {
      marginRight: '10px',
      color: 'hsl(0, 0%, 55%)',
      fontSize: '19px'
    },
    '& > span': {
      color: 'hsl(0, 0%, 50%)',
      textTransform: 'uppercase',
      fontWeight: '400'
    },
    '&:hover': {
      border: '2px dashed hsl(0, 0%, 45%)',
      '& > .material-icons': {
        color: 'hsl(0, 0%, 25%)'
      },
      '& > span': {
        color: 'hsl(0, 0%, 20%)'
      }
    }
  }
};

export default injectSheet(styles)(AddComponent);
